import * as React from 'react';

import {CueCard} from 'shells/cue-card/cue-card';
import {Illustration} from 'shells/illustrations/illustration';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {QuoteAndInvoiceInfoModal} from 'shells/modal/quote-and-invoice-info-modal';
import {Body} from 'shells/typography/body';

import {InvoiceWrapper} from '../../../lead/sales-documents/invoices/components/invoice-wrapper';
import {useGetInvoiceTemplate} from '../../../lead/sales-documents/invoices/graphql/hooks/use-get-invoice-template';

import {appHistory} from '../../../../history';

import {convertTemplateToInvoice} from '../shared/helper';

import styles from '../quotes/quote-template-page.module.css';

export function InvoiceTemplatePage() {
    const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
    const [isCardMinimized, setIsCardMinimized] = React.useState<boolean>(false);

    const {invoiceTemplate, isLoading} = useGetInvoiceTemplate();

    if (isLoading) {
        return <LoadingPage />;
    }

    return (
        <div className={styles['quote-template-container-outer']}>
            {!isCardMinimized && (
                <div className={styles['cue-card-container']}>
                    <CueCard
                        title='Professional invoices, directly from a lead'
                        description='Customize your invoice template with your logo, payment terms and contact info.'
                        thumbnailIllustration={<Illustration src='invoice' />}
                        thumbnailBackgroundColor='plumLt'
                        withBookmarkIcon={true}
                        history={appHistory}
                        cta={{
                            text: 'Learn more',
                            actionType: 'modal',
                            onClick: () => setIsModalOpen(true),
                        }}
                        onMinimize={() => setIsCardMinimized(true)}
                    />
                </div>
            )}
            <div className={styles['quote-template-header']}>
                <Body isBold={true} size={'large'}>
                    Invoice defaults
                </Body>
            </div>
            <div className={styles['quote-template-container-inner']}>
                <InvoiceWrapper
                    invoice={convertTemplateToInvoice(invoiceTemplate)}
                    isTemplate={true}
                    toggleHasActiveSection={() => {}}
                />
            </div>
            {isModalOpen && (
                <QuoteAndInvoiceInfoModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                />
            )}
        </div>
    );
}
